import { Grid } from '@material-ui/core';
import {
  EntityLayout,
  EntitySwitch,
  isComponentType,
} from '@backstage/plugin-catalog';
import {
  EntityConsumedApisCard,
  EntityProvidedApisCard,
} from '@backstage/plugin-api-docs';
import { isKubernetesAvailable } from '@backstage/plugin-kubernetes';
import { cicdTab, dependenciesTab, kubernetesTab, overviewTab, techdocsTab } from '../shared/tabs';

const serviceEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Resumo">{overviewTab}</EntityLayout.Route>
    <EntityLayout.Route path="/ci-cd" title="CI/CD">{cicdTab}</EntityLayout.Route>
    <EntityLayout.Route path="/kubernetes" title="Kubernetes" if={isKubernetesAvailable}>{kubernetesTab}</EntityLayout.Route>
    <EntityLayout.Route path="/api" title="API">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6}><EntityProvidedApisCard /></Grid>
        <Grid item md={6}><EntityConsumedApisCard /></Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/dependencies" title="Dependências">{dependenciesTab}</EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Documentação">{techdocsTab}</EntityLayout.Route>
  </EntityLayout>
);

const aplicacaoIaEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Resumo">{overviewTab}</EntityLayout.Route>
    <EntityLayout.Route path="/kubernetes" title="Kubernetes" if={isKubernetesAvailable}>{kubernetesTab}</EntityLayout.Route>
    <EntityLayout.Route path="/dependencies" title="Dependências">{dependenciesTab}</EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Documentação">{techdocsTab}</EntityLayout.Route>
  </EntityLayout>
);

const websiteEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Resumo">{overviewTab}</EntityLayout.Route>
    <EntityLayout.Route path="/ci-cd" title="CI/CD">{cicdTab}</EntityLayout.Route>
    <EntityLayout.Route path="/kubernetes" title="Kubernetes" if={isKubernetesAvailable}>{kubernetesTab}</EntityLayout.Route>
    <EntityLayout.Route path="/dependencies" title="Dependências">{dependenciesTab}</EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Documentação">{techdocsTab}</EntityLayout.Route>
  </EntityLayout>
);

const defaultEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Resumo">{overviewTab}</EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Documentação">{techdocsTab}</EntityLayout.Route>
  </EntityLayout>
);

export const componentPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType('service')}>{serviceEntityPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isComponentType('Aplicação IA')}>{aplicacaoIaEntityPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isComponentType('website')}>{websiteEntityPage}</EntitySwitch.Case>
    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
